// KnowledgeBase.js
import React from "react";
import "./HelpCenter.css";

const items = [
  {
    title: "Portal Updates",
    description:
      "See what's new in Nobelflow to make your day that much easier.",
  },
  {
    title: "Getting Started",
    description:
      "Learn how to set up your account and begin placing your requests.",
  },
  {
    title: "Authorizations",
    description:
      "Articles to guide you on the submission process of authorization forms.",
  },
  {
    title: "Records Requests",
    description: "Check out how to easily submit requests through our portal.",
  },
  {
    title: "Clients and Staff Users",
    description: "Manage your clients and staff",
  },
  {
    title: "Organization/Account Settings",
    description:
      "Billing/admin inquiries and how to access account statements.",
  },
  {
    title: "Cancellation/Refund Policies",
    description: "Learn more about our cancellation and refund policies.",
  },
  { title: "FAQ", description: "Frequently asked questions from our users." },
  {
    title: "Filevine Integration Resources",
    description:
      "Further information on how to integrate Filevine with your organization's account.",
  },
  {
    title: "NobelFlow Desk Guide",
    description: "Digital Desk Guide - Your guide to NobelFlow best practices",
  },
  {
    title: "Service Standards",
    description:
      "View a copy of our follow-up schedules and Service Standard for various types of requests.",
  },
  {
    title: "Records Summarization",
    description:
      "Learn more about our summarization services and how they could benefit your organization.",
  },
];

export default function HelpCenter() {
  return (
    <div className="kb-container">
      <h2 className="kb-title">Knowledge base</h2>
      <div className="kb-grid">
        {items.map((item, idx) => (
          <div className="kb-card" key={idx}>
            <span className="kb-card-title">{item.title}</span>
            <span className="kb-card-description">{item.description}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
